module.exports = __webpack_public_path__ + "static/media/feishu_chat.49b51efd.png";